export const networkParams = {
    // "0x63564c40": {
    //     chainId: "0x63564c40",
    //     rpcUrls: ["https://api.harmony.one"],
    //     chainName: "Harmony Mainnet",
    //     nativeCurrency: { name: "ONE", decimals: 18, symbol: "ONE" },
    //     blockExplorerUrls: ["https://explorer.harmony.one"],
    //     iconUrls: ["https://harmonynews.one/wp-content/uploads/2019/11/slfdjs.png"]
    // },
    // "0xa4ec": {
    //     chainId: "0xa4ec",
    //     rpcUrls: ["https://forno.celo.org"],
    //     chainName: "Celo Mainnet",
    //     nativeCurrency: { name: "CELO", decimals: 18, symbol: "CELO" },
    //     blockExplorerUrl: ["https://explorer.celo.org"],
    //     iconUrls: [
    //         "https://celo.org/images/marketplace-icons/icon-celo-CELO-color-f.svg"
    //     ]
    // },
    "0x1": {
        chainId: "0x38",
        rpcUrls: ["https://mainnet.infura.io/v3"],
        chainName: "Ethereum Mainnet",
        nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
        blockExplorerUrl: ["https://etherscan.io"],
        // iconUrls: [
        //     "https://celo.org/images/marketplace-icons/icon-celo-CELO-color-f.svg"
        // ]
    },
    "0x38": {
        chainId: "0x38",
        rpcUrls: ["https://bsc-dataseed.binance.org"],
        chainName: "Binance Smart Chain",
        nativeCurrency: { name: "BNB", decimals: 18, symbol: "BNB" },
        blockExplorerUrl: ["https://bscscan.com/"],
        // iconUrls: [
        //     "https://celo.org/images/marketplace-icons/icon-celo-CELO-color-f.svg"
        // ]
    },
    "0x89": {
        chainId: "0x89",
        rpcUrls: ["https://polygon-rpc.com"],
        chainName: "Polygon Mainnet",
        nativeCurrency: { name: "MATIC", decimals: 18, symbol: "MATIC" },
        blockExplorerUrl: ["https://polygonscan.com"],
        // iconUrls: [
        //     "https://celo.org/images/marketplace-icons/icon-celo-CELO-color-f.svg"
        // ]
    }

};